<script lang="ts" setup>
	import type { AlertVariant } from '~/components/Ui/alert.vue'

	const props = defineProps<{
		planDetails: PlanInformationContext | null
	}>()
	const { daysLeft } = useUtils()
	const { formatDate } = useCustomDate()
	const progressDisplay = shallowRef({
		daysLeft: 0,
		progress: 0,
		showDate: true,
		showProgress: true
	})
	const timer = useCountdown(props.planDetails?.wait_until ?? '')

	const detailsPreview = computed(() => {
		const message = {
			active: false,
			text: '',
			subText: '',
			countdownLabel: '',
			icon: {
				dir: 'fill',
				name: 'warning',
				class: 'fill-purple-500'
			},
			variant: 'purple' as AlertVariant,
			countdown: false,
			trailColor: '#D9D6FE',
			progressColor: '#7A5AF8',
			dateClass: 'text-purple-500'
		}
		if (props.planDetails?.is_deactivated) {
			message.active = true
			if (props.planDetails?.is_deactivated) {
				message.text = 'Your plan is Deactivated'
				message.variant = 'error'
				message.countdown = !props.planDetails?.is_deactivated
				message.trailColor = '#FECDCA'
				message.progressColor = '#F04438'
				message.dateClass = 'text-error-500'
				progressDisplay.value.showDate = false
				progressDisplay.value.showProgress = false
			}
		}
		if (props.planDetails?.wait_until && !props.planDetails?.is_expired) {
			const dayLeft = daysLeft(props.planDetails.wait_until ?? '')
			if (Number(dayLeft?.daysDiff || 0) < 7) {
				message.text = `Your staff policies will activate on ${formatDate(
					props.planDetails.wait_until,
					'Do of MMMM, YYYY'
				)} after a 24-hour wait period.`
				message.subText = 'The wait time applies because renewal was completed within 7 days of expiration.'
			} else if (Number(dayLeft?.daysDiff || 0) >= 7) {
				message.text = `Your staff policies will activate on ${formatDate(
					props.planDetails.wait_until,
					'Do of MMMM, YYYY'
				)}, after a 7days  wait period`
				message.subText = 'The wait time applies because renewal was completed after 7 days of  expiration.'
			}
			// timer
			if (timer.days > 0) {
				message.countdownLabel = `${timer.days} day${timer.days > 1 ? 's' : ''} left`
			} else if (timer.hours > 0) {
				message.countdownLabel = `${timer.hours} hour${timer.hours > 1 ? 's' : ''} left`
			} else if (timer.minutes > 0) {
				message.countdownLabel = `${timer.minutes} minute${timer.minutes > 1 ? 's' : ''} left`
			}
			progressDisplay.value.progress = timer.hours + timer.minutes
			message.active = Boolean(timer.days || timer.hours || timer.minutes)
			message.variant = 'warning'
			message.trailColor = '#FEDF89'
			message.progressColor = '#F79009'
			message.dateClass = 'text-warning-500'
		}
		if (props.planDetails?.is_expired) {
			message.active = true
			message.text = 'Your plan has expired.'
			message.variant = 'error'
			progressDisplay.value.showDate = false
		}
		return message
	})
</script>

<template>
	<ui-alert v-if="detailsPreview.active" class="mb-5" :variant="detailsPreview.variant">
		<div>
			<p>{{ detailsPreview.text }}</p>
			<p class="text-xs">
				{{ detailsPreview.subText }}
			</p>
		</div>

		<template #prefix>
			<div v-if="progressDisplay.showDate" class="inline-flex flex-1 items-start gap-x-2">
				<span :class="detailsPreview.dateClass" class="md:whitespace-nowrap">
					{{ detailsPreview.countdownLabel }}
				</span>
				<a-progress
					v-show="progressDisplay.showProgress"
					:percent="progressDisplay.progress"
					:show-info="false"
					class="max-w-[200px]"
					:trail-color="detailsPreview.trailColor"
					:stroke-color="detailsPreview.progressColor"
				/>
			</div>
		</template>
	</ui-alert>
</template>
